import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import { Search, Filter, CheckCircle, Clock, XCircle } from "lucide-react";

export default function ErrorsList() {
  const errors = [
    {
      id: 1,
      title: "TypeError: Cannot read property 'map' of undefined",
      file: "src/components/UserList.tsx:42",
      status: "fixed",
      occurrences: 12,
      firstSeen: "2 days ago",
      lastSeen: "2 hours ago",
    },
    {
      id: 2,
      title: "ReferenceError: userId is not defined",
      file: "src/api/users.ts:128",
      status: "pending",
      occurrences: 8,
      firstSeen: "1 day ago",
      lastSeen: "4 hours ago",
    },
    {
      id: 3,
      title: "UnhandledPromiseRejection: Network request failed",
      file: "src/services/api.ts:56",
      status: "reviewing",
      occurrences: 24,
      firstSeen: "3 days ago",
      lastSeen: "6 hours ago",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <h1 className="text-2xl font-heading font-bold">Healion.ai</h1>
            <nav className="hidden md:flex gap-6">
              <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-foreground">
                Dashboard
              </Link>
              <Link to="/errors" className="text-sm font-medium border-b-2 border-foreground pb-1">
                Errors
              </Link>
              <Link to="/connections" className="text-sm text-muted-foreground hover:text-foreground">
                Connections
              </Link>
              <Link to="/analytics" className="text-sm text-muted-foreground hover:text-foreground">
                Analytics
              </Link>
              <Link to="/settings" className="text-sm text-muted-foreground hover:text-foreground">
                Settings
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-heading font-bold mb-2">All Errors</h1>
            <p className="text-muted-foreground">View and manage all detected errors</p>
          </div>
        </div>

        {/* Filters */}
        <div className="flex gap-4 mb-6">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input placeholder="Search errors..." className="pl-10" />
          </div>
          <Button variant="outline">
            <Filter className="mr-2 w-4 h-4" />
            Filter
          </Button>
        </div>

        {/* Tabs */}
        <div className="flex gap-4 mb-6 border-b">
          <button className="pb-2 px-1 text-sm font-medium border-b-2 border-foreground">
            All ({errors.length})
          </button>
          <button className="pb-2 px-1 text-sm text-muted-foreground hover:text-foreground">
            Fixed (1)
          </button>
          <button className="pb-2 px-1 text-sm text-muted-foreground hover:text-foreground">
            Pending (1)
          </button>
          <button className="pb-2 px-1 text-sm text-muted-foreground hover:text-foreground">
            Reviewing (1)
          </button>
        </div>

        {/* Errors List */}
        <div className="space-y-4">
          {errors.map((error) => (
            <Card key={error.id} className="p-6 border-2 hover:border-foreground/20 transition-colors">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-1">
                  {error.status === "fixed" && <CheckCircle className="w-6 h-6 text-green-600" />}
                  {error.status === "pending" && <Clock className="w-6 h-6 text-yellow-600" />}
                  {error.status === "reviewing" && <Clock className="w-6 h-6 text-blue-600" />}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-lg mb-2">{error.title}</h3>
                  <p className="text-sm text-muted-foreground mb-4">{error.file}</p>
                  <div className="flex flex-wrap items-center gap-4 text-sm">
                    <span className={`px-3 py-1 rounded-full ${
                      error.status === "fixed" ? "bg-green-600/10 text-green-600" :
                      error.status === "pending" ? "bg-yellow-600/10 text-yellow-600" :
                      "bg-blue-600/10 text-blue-600"
                    }`}>
                      {error.status}
                    </span>
                    <span className="text-muted-foreground">
                      {error.occurrences} occurrences
                    </span>
                    <span className="text-muted-foreground">
                      First: {error.firstSeen}
                    </span>
                    <span className="text-muted-foreground">
                      Last: {error.lastSeen}
                    </span>
                  </div>
                </div>
                <Button variant="outline">View Details</Button>
              </div>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
}
